import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'attendantCompanyId',
    label: 'Title/Escrow/Attorney Company',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'contactPerson',
    label: 'Contact Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'contactPhone',
    label: 'Contact Phone',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'contactEmail',
    label: 'Contact Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'escrowNumber',
    label: 'Escrow Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const closingCompanyInformationForm = {
  name: FormNames.CLOSING_COMPANY_INFORMATION,
  label: 'Title/Settlement Agent/Attorney(s)',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
